import { FC, useState } from 'react';
import { Box, TextField, useTheme } from '@mui/material';
import './DatePicker.css';
import dayjs, { Dayjs } from 'dayjs';

interface DatePickerProps {
  label?: string;
  selectedDate: Dayjs | null;
  onDateChange: (date: Dayjs) => void;
}

const DatePicker: FC<DatePickerProps> = ({
  label,
  selectedDate,
  onDateChange,
}) => {
  const theme = useTheme();
  const [currentDate, setCurrentDate] = useState<Dayjs | null>(
    selectedDate || null
  );

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = dayjs(event.target.value);
    setCurrentDate(newDate);
    onDateChange(newDate);
  };

  return (
    <Box margin={theme.spacing(1)}>
      <TextField
        type="date"
        id="datepicker"
        className="datepicker"
        sx={{ verticalAlign: 'unset' }}
        defaultValue={
          currentDate ? currentDate.toISOString().substring(0, 10) : null
        }
        onChange={handleDateChange}
        label={label}
        fullWidth
        InputLabelProps={{ shrink: true }}
      />
    </Box>
  );
};

export default DatePicker;

// Example
// function App() {
//   const [selectedDate, setSelectedDate] = useState(new Date());

//   const handleDateChange = (date: Date) => {
//     setSelectedDate(date);
//   };

//   return (
//     <div className='App'>
//       <h1>Date Picker</h1>
//       <DatePicker selectedDate={selectedDate} onDateChange={handleDateChange} />
//       <p>Selected Date: {selectedDate.toString()}</p>
//     </div>
//   );
// }
